module.exports = __webpack_public_path__ + "static/img/qs1_12.f486e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/qs1_12.png
// module id = uV4L
// module chunks = 3